import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CorporateRoutingModule } from './corporate-routing.module';
import { CorporateAddComponent } from './components/corporate-add/corporate-add.component';
import { CorporateListComponent } from './components/corporate-list/corporate-list.component';
import { CorporatePageComponent } from './components/corporate-page/corporate-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    CorporateAddComponent,
    CorporateListComponent,
    CorporatePageComponent,
  ],
  imports: [
    CommonModule,
    CorporateRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    IonicModule.forRoot(),
    NgxMatSelectSearchModule,
    DatepickerModule,
    BsDatepickerModule.forRoot(),
    CKEditorModule,
  ],
})
export class CorporateModule {}
